import _ from 'lodash';
import {
  REQUEST_TAX_PROFESSIONS,
  RECEIVE_TAX_PROFESSIONS,
  SET_SELECTED_PROFESSIONS,
  ADD_TAX_PROFESSION,
  REMOVE_TAX_PROFESSION,
  SET_TOKEN,
} from '../../actions/tax/professions';

const initialState = {
  content: [],
  mileageTypes: [],
  selected: [],
  defaulted: false,
  isFetching: false,
  token: null,
};

export default function professions(state = initialState, action) {
  switch (action.type) {
    case REQUEST_TAX_PROFESSIONS:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_TAX_PROFESSIONS:
      return {
        ...state,
        content: action.professions,
        mileageTypes: action.mileageTypes,
        defaulted: !!action.defaulted,
        selected: action.selected,
        isFetching: false,
      };
    case SET_SELECTED_PROFESSIONS:
      return {
        ...state,
        selected: action.professionIds,
      };
    case ADD_TAX_PROFESSION:
      return {
        ...state,
        selected: [...state.selected, action.professionId],
      };
    case REMOVE_TAX_PROFESSION:
      return {
        ...state,
        selected: _.without(state.selected, action.professionId),
      };
    case SET_TOKEN:
      return {
        ...state,
        token: action.token,
      };
    default:
      return state;
  }
}
